import { BaseSeries } from "../table-transforms/series-utils";

/**
 * Union type representing data that can be displayed in the side panel.
 * Can be either a series of related resources or a single resource.
 */
export type SidePanelData<T> =
  | {
      type: "series";
      series: BaseSeries<T>;
    }
  | {
      type: "single";
      resource: T;
      metadata: {
        date: string;
        displayName: string;
      };
    };

/**
 * Custom section renderer function for resource-specific content in the sidepanel
 */
export type CustomSectionRenderer = (
  data: SidePanelData<unknown>,
  onViewPdf?: (docId: string) => void
) => React.ReactNode | null;

/**
 * Type guard to check if data is a series
 */
export function isSeries<T>(
  data: SidePanelData<T>
): data is { type: "series"; series: BaseSeries<T> } {
  return data.type === "series";
}

/**
 * Type guard to check if data is a single resource
 */
export function isSingleResource<T>(data: SidePanelData<T>): data is {
  type: "single";
  resource: T;
  metadata: { date: string; displayName: string };
} {
  return data.type === "single";
}
